module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 border-right margin-b50"
  }, [_c('div', {
    staticClass: "content-box-login margin-t20"
  }, [(_vm.errorMessage == 'Usuário e/ou senha inválidos') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage),
      expression: "errorMessage"
    }],
    staticClass: "alert alert-danger margin-b10"
  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage != 'Usuário e/ou senha inválidos') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage),
      expression: "errorMessage"
    }],
    staticClass: "alert alert-danger margin-b10"
  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('form', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "action": "index.html",
      "novalidate": "",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doLogin.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('taxIdNumber')
    }
  }, [_c('label', [_vm._v("CPF ou CNPJ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.taxIdNumber),
      expression: "taxIdNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cpfCnpj'),
      expression: "'required|cpfCnpj'"
    }, {
      name: "mask-cpf-cnpj",
      rawName: "v-mask-cpf-cnpj"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "tel",
      "inputmode": "numeric",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
      "name": "taxIdNumber",
      "data-vv-validate-on": "blur",
      "placeholder": "Digite seu CPF ou CNPJ",
      "maxlength": "18",
      "autofocus": "",
      "novalidate": "",
      "formnovalidate": ""
    },
    domProps: {
      "value": (_vm.taxIdNumber)
    },
    on: {
      "change": function($event) {
        _vm.taxIdNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('taxIdNumber')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('label', [_vm._v("Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "password",
      "name": "password",
      "data-vv-rules": "required",
      "placeholder": "Mínimo 8 e máximo 20 caracteres",
      "maxlength": "20",
      "autocomplete": "false"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saveTaxId),
      expression: "saveTaxId"
    }],
    staticClass: "check-terms",
    attrs: {
      "id": "saveTaxId",
      "type": "checkbox",
      "name": "saveTaxId",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.saveTaxId) ? _vm._i(_vm.saveTaxId, "") > -1 : (_vm.saveTaxId)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.saveTaxId,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.saveTaxId = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.saveTaxId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.saveTaxId = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-terms",
    attrs: {
      "for": "saveTaxId"
    }
  }, [_vm._v("Lembrar usuário e senha")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "link-box-login row row-fix"
  }, [_c('div', {
    staticClass: "col-xs-6 col-fix"
  }, [_c('router-link', {
    staticClass: "forgot-pass make-link",
    attrs: {
      "to": {
        name: 'password-request',
        params: {
          type: '2fa'
        },
        query: {
          taxIdNumber: _vm.taxIdNumber
        }
      }
    }
  }, [_vm._v("Primeiros Passos")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-fix text-right"
  }, [_c('router-link', {
    staticClass: "forgot-pass make-link",
    attrs: {
      "to": {
        name: 'password-request',
        params: {
          type: 'reset'
        },
        query: {
          taxIdNumber: _vm.taxIdNumber
        }
      }
    }
  }, [_vm._v("Esqueci minha senha")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 border-right margin-b50",
    staticStyle: {
      "margin-top": "-3px"
    }
  }, [_c('div', {
    staticClass: "content-box-login text-center"
  }, [_c('h2', {
    staticClass: "head-info"
  }, [_vm._v("+ para você")]), _vm._v(" "), _c('h3', {
    staticClass: "title-info-new margin-b20"
  }, [_vm._v("Conheça nossos serviços e planos")]), _vm._v(" "), _c('p', [_vm._v("Com certeza temos um ideal para você.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-default margin-t15",
    attrs: {
      "to": {
        name: 'services-b2c'
      }
    }
  }, [_vm._v("\n              Ver Planos\n            ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right-inverse align-icon"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "-3px"
    }
  }, [_c('div', {
    staticClass: "content-box-login text-center"
  }, [_c('h2', {
    staticClass: "head-info"
  }, [_vm._v("+ para sua empresa")]), _vm._v(" "), _c('h3', {
    staticClass: "title-info-new margin-b20"
  }, [_vm._v("Tem uma frota e ainda não tem um plano?")]), _vm._v(" "), _c('p', [_vm._v("Temos soluções especiais para empresas.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-default margin-t15",
    attrs: {
      "to": {
        name: 'services-b2b'
      }
    }
  }, [_vm._v("\n              Ver Planos\n            ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right-inverse align-icon"
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Identificação")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('p', [_vm._v("Você precisa ter um cadastro para continuar:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-purple",
    attrs: {
      "id": "btn-login",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n                  Continuar\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-73ed0caa!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/login.vue
// module id = 2169
// module chunks = 1